// extracted by mini-css-extract-plugin
module.exports = {"ProfileImage":"_1WR9f","SkeletonImage":"pB__V","Small":"_1tJOR","Large":"rX_UC"};